export default "__VITE_ASSET__Cf3zeyOm__"